<template>
  <div class="auth-popup-phone-check">
    <div class="auth-popup-phone-check__desc">
      {{ getDescText }}
    </div>
    <div class="auth-popup-phone-check__wrapper">
      <input
        type="text"
        v-model="code"
        placeholder="SMS пароль">
    </div>
    <div class="auth-popup-phone-check__wrapper-btn">
      <div
        class="authorize-links__item link"
        @click="checkCode">Далее
      </div>
    </div>
    <div
      class="auth-popup-phone-check__send-wrapper"
      @click="sendPhone"
      :class="{active: active}">
      {{ this.timerText }}
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import isEmpty from 'lodash/isEmpty'

  export default {
    name: 'PhoneCheckPopup',
    data: function () {
      return {
        code: '',
        sec: 60,
        timerText: '',
        active: false
      }
    },
    mounted: function () {
      this.runTimer()
    },
    computed: {
      ...mapGetters('auth', [
        'getCurrentPhone'
      ]),
      getDescText: function () {
        return `Вам отправлено SMS с одноразовым паролем на номер ${this.getCurrentPhone}`
      }
    },
    methods: {
      ...mapActions('auth', [
        'sendSmsByPhone',
        'checkPhoneCode'
      ]),
      runTimer: function () {
        let iterate = 0
        const interval = setInterval(() => {
          if (this.sec > iterate) {
            iterate++
            this.active = false
            this.timerText = `Отправить пароль через ${this.sec - iterate} сек`
          } else {
            clearInterval(interval)
            this.active = true
            this.timerText = `Отправить пароль еще раз`
          }
        }, 1000)
      },
      sendPhone: function () {
        this.runTimer()
        this.sendSmsByPhone({
          phone: this.getCurrentPhone
        })
      },
      checkCode: function () {
        if (!isEmpty(this.code)) {
          this.checkPhoneCode({
            code: this.code
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Popups/PhoneCheckPopup.vue